import { render, staticRenderFns } from "./MediaCollections.vue?vue&type=template&id=5bb0bd42&scoped=true"
import script from "./MediaCollections.vue?vue&type=script&lang=js"
export * from "./MediaCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb0bd42",
  null
  
)

export default component.exports